import { WSPanelLang } from './wsList/wsPanelList.lang';
import { AnswerListLang } from './answerList/answerList.lang';
import { answerDetailLang } from './answerDetail/answerDetail.lang';

export const WSPanelAllLang = {
    forms: 'لیست فرم ها',
    panel: WSPanelLang,
    answerList: AnswerListLang,
    answerDetail: answerDetailLang,
};
